// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import snackbarReducer from './slices/snackbar';
import customerReducer from './slices/customer';
import contactReducer from './slices/contact';
import productReducer from './slices/product';
import chatReducer from './slices/chat';
import calendarReducer from './slices/calendar';
import mailReducer from './slices/mail';
import userReducer from './slices/user';
import dataReducer from './slices/data';
import kanbanReducer from './slices/kanban';
import menuReducer from './slices/menu';
import settingsReducer from './slices/settings';
import logsReducer from './slices/logs';
import backdropReducer from './slices/backdrop';
import apiUserReducer from './slices/api-user';
import courseReducer from './slices/course';
import candidateReducer from './slices/candidate';
import candidateAssessmentReducer from './slices/candidate-assessment';
import guestEvidenceReducer from './slices/guest-evidence';
import backendProcessReducer from './slices/backend-process';
import analyticsReducer from './slices/analytics';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    snackbar: snackbarReducer,
    data: persistReducer(
        {
            key: 'data',
            storage,
            keyPrefix: 'lln-robot-'
        },
        dataReducer
    ),
    kanban: kanbanReducer,
    customer: customerReducer,
    contact: contactReducer,
    product: productReducer,
    chat: chatReducer,
    calendar: calendarReducer,
    mail: mailReducer,
    user: userReducer,
    menu: menuReducer,
    settings: settingsReducer,
    logs: logsReducer,
    backdrop: backdropReducer,
    apiuser: apiUserReducer,
    course: courseReducer,
    candidate: candidateReducer,
    candidateAssessment: candidateAssessmentReducer,
    guestEvidence: guestEvidenceReducer,
    backendProcess: backendProcessReducer,
    analytics: analyticsReducer
});

export default reducer;
